
export default {
  name: 'QrContainer',
  props: {
    qrInfo: {
      type: Object,
      default: () => { },
    },
    qrData: {
      type: String,
      default: '',
    },
    invitationInfo: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      qrSrc: require('@/assets/images/main/qr-login.png'),
      activeQrModal: false,
      activeInviteModal: false,
    };
  },
  computed: {
    invitation() {
      return this.invitationInfo?.data?.[0] ?? null;
    },
    convertSerial() {
      if (!this.$auth.user?.serial_number) return '';
      return this.$auth.user?.serial_number
        .slice(0, -1)
        .padStart(8, '0')
        .padStart(9, 'N')
        .replace(/(\w{1})(\d{4})(\d{4})/g, '$1-$2-$3');
    },
  },
  methods: {
    test() {
      this.activeQrModal = true;
    },
    async handleAnswerInvitation(answer) {
      const response = await this.$axios.post(`/api/auth/home/management-invitations/${this.invitation.id}/approve`, {
        allow: answer,
      });
      if (response.data) {
        alert(response.data.message);
        this.activeInviteModal = false;
        this.$emit('refreshInvitation');
      }
    },
  },
};
